export const getObjectDeepProperty = (object: Record<string, any>, path: string): any => {
  const [name, ...restPath] = path.split('.')
  if (!restPath.length) return object?.[name]
  if (!object) return undefined
  return getObjectDeepProperty(object[name], restPath.join('.'))
}

export const softCompare = (obj1: Record<string, any>, obj2: Record<string, any>): boolean => {
  if ((!obj1 && obj2) || (obj1 && !obj2)) return false
  if (!obj1 && !obj2) return true
  return JSON.stringify(sortObject(obj1)) === JSON.stringify(sortObject(obj2))
}

const sortObject = (object: Record<string, any>): Record<string, any> =>
  Object.fromEntries(Object.entries(object).sort())
